"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ButtonColumn;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _modelUtils = require("~/utils/modelUtils");
const _utils = require("~/utils");
const _Filter = /*#__PURE__*/ _interop_require_default(require("~/models/Filter"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
let ButtonColumn = class ButtonColumn {
    static async insert(context, buttonColumn, ncMeta = _Noco.default.ncMeta) {
        const urlProps = [
            'formula_raw',
            'formula',
            'error',
            'parsed_tree'
        ];
        const webhookProps = [
            'fk_webhook_id'
        ];
        const scriptProps = [
            'fk_script_id'
        ];
        const aiProps = [
            'formula_raw',
            'formula',
            'error',
            'fk_integration_id',
            'model',
            'output_column_ids'
        ];
        const insertObj = (0, _extractProps.extractProps)(buttonColumn, [
            ...buttonColumn.type === _nocodbsdk.ButtonActionsType.Url ? urlProps : buttonColumn.type === _nocodbsdk.ButtonActionsType.Webhook ? webhookProps : buttonColumn.type === _nocodbsdk.ButtonActionsType.Script && _utils.isEE ? scriptProps : buttonColumn.type === _nocodbsdk.ButtonActionsType.Ai ? aiProps : [],
            'theme',
            'color',
            'label',
            'type',
            'icon',
            'fk_column_id'
        ]);
        if (buttonColumn.type === _nocodbsdk.ButtonActionsType.Url) {
            insertObj.parsed_tree = (0, _modelUtils.stringifyMetaProp)(insertObj, 'parsed_tree', null);
        }
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.COL_BUTTON, insertObj);
        return this.read(context, buttonColumn.fk_column_id, ncMeta);
    }
    static async read(context, columnId, ncMeta = _Noco.default.ncMeta) {
        let column = columnId && await _NocoCache.default.get(context, `${_globals.CacheScope.COL_BUTTON}:${columnId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!column) {
            column = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COL_BUTTON, {
                fk_column_id: columnId
            });
            if (column) {
                if (column.type === _nocodbsdk.ButtonActionsType.Url) {
                    column.parsed_tree = (0, _modelUtils.parseMetaProp)(column, 'parsed_tree', null);
                }
                await _NocoCache.default.set(context, `${_globals.CacheScope.COL_BUTTON}:${columnId}`, column);
            }
        }
        if (column) {
            column.filters = await _Filter.default.allButtonFilterList(context, {
                buttonColId: columnId
            }, ncMeta);
        }
        return column ? new ButtonColumn(column) : null;
    }
    static async update(context, columnId, button, ncMeta = _Noco.default.ncMeta) {
        const urlProps = [
            'fk_column_id',
            'formula_raw',
            'formula',
            'error',
            'parsed_tree'
        ];
        const webhookProps = [
            'fk_webhook_id'
        ];
        const scriptProps = [
            'fk_script_id'
        ];
        const aiProps = [
            'formula_raw',
            'formula',
            'error',
            'fk_integration_id',
            'model',
            'output_column_ids'
        ];
        const updateObj = (0, _extractProps.extractProps)(button, [
            ...button.type === _nocodbsdk.ButtonActionsType.Url ? urlProps : button.type === _nocodbsdk.ButtonActionsType.Webhook ? webhookProps : button.type === _nocodbsdk.ButtonActionsType.Script && _utils.isEE ? scriptProps : button.type === _nocodbsdk.ButtonActionsType.Ai ? aiProps : [],
            'theme',
            'color',
            'type',
            'icon',
            'label'
        ]);
        if (button.type === _nocodbsdk.ButtonActionsType.Url) {
            button.parsed_tree = (0, _modelUtils.stringifyMetaProp)(button, 'parsed_tree', null);
        }
        if ('parsed_tree' in updateObj) updateObj.parsed_tree = (0, _modelUtils.stringifyMetaProp)(updateObj, 'parsed_tree', null);
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.COL_BUTTON, updateObj, {
            fk_column_id: columnId
        });
        await _NocoCache.default.update(context, `${_globals.CacheScope.COL_BUTTON}:${columnId}`, updateObj);
    }
    getParsedTree() {
        return this.parsed_tree;
    }
    static async buttonUsages(context, scriptId, ncMeta = _Noco.default.ncMeta) {
        return await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_BUTTON, {
            condition: {
                fk_script_id: scriptId
            }
        });
    }
    constructor(data){
        const { parsed_tree } = data, rest = _object_without_properties_loose(data, [
            "parsed_tree"
        ]);
        this.parsed_tree = parsed_tree;
        Object.assign(this, rest);
    }
};
